module.exports = __webpack_public_path__ + "static/media/logo.e61cc18a.png";